<template>
  <div class="text-center">
    <v-progress-circular
      :size="100"
      :width="10"
      color="#0f3852"
      indeterminate
    ></v-progress-circular>
    <!-- <img  :size="50" src="../assets/loader.gif" class="mt-1"> -->
  </div>
</template>
<script>
export default {
  props: [
    'token',
    'tax_id'
  ],
  data() {
    return {
      kill: false,
      selectedBranch: null
    }
  },
  mounted () {
    //console.log(this.token)
    if (this.token) this.setToken()
  },
  methods:{
    error_swal_fn (msg = "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง") {
      this.$swal({
        backdrop: false,
        position: 'bottom-end',
        width: '330px',
        title: '<svg style="width:24px;height:24px" class="alert-icon" viewBox="0 0 24 24"><path fill="#E53935" d="M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M15.59,7L12,10.59L8.41,7L7,8.41L10.59,12L7,15.59L8.41,17L12,13.41L15.59,17L17,15.59L13.41,12L17,8.41L15.59,7Z" /></svg><strong class="alert-title">เกิดข้อผิดพลาด</strong>',
        html: msg,
        showCloseButton: true,
        showConfirmButton: false,
        timer: 0,
        customClass: {
          popup: 'alert-card',
          title: 'alert-title-block',
          closeButton: 'close-alert-btn',
          htmlContainer: 'alert-text-block'
        }
      })
    },
    async setToken(){
      try {
        this.$apiConfig.setToken(this.token)
        this.$apiConfig.setRefreshToken(this.token)
        sessionStorage.setItem('access_token', `${this.token}`)
        sessionStorage.setItem('refresh_token', `${this.token}`)

        this.getUserDetail()
        this.getUser()
      } catch (error) {
        console.log(error);
      }
    },
    async getUserDetail(){ // get user detail to show name, email and business list
        if(this.kill) return
        try {
          var url = '/citizen/api/v1/detail'
          var { data } = await this.axios.get(this.$dwf_url + url)
          if(data) {
            this.username = data.data.username
            sessionStorage.setItem('name', `${data.data.first_name_th} ${data.data.last_name_th}`)
            sessionStorage.setItem('userProfile', JSON.stringify(data.data))
            if(this.tax_id) {
              //sessionStorage.setItem('tax_id', this.tax_id)
              sessionStorage.setItem('tax_id', JSON.stringify(this.tax_id))
              sessionStorage.setItem('tax_id_original', JSON.stringify(this.tax_id))
            }
            this.$router.push("/pettycash_hc_dashboard/dashboard")
          }
        } catch (error) {
          console.log(error);
        }
      },
    async getUser(){ // get user detail to show name, email and business list
        try {
          var url = '/petty_cash/api/v1/userlogCitizen'
          var { data } = await this.axios.get(this.$api_url + url)
        } catch (error) {
          console.log(error);
        }
    },
  }
}
</script>
<style scoped>
.v-progress-circular {
  margin: 5rem;
}
</style>